
import { useState } from 'react';

interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  cities: string[];
  activeCity: string;
  onCityChange: (city: string) => void;
}

const CategoryFilter = ({
  categories,
  activeCategory,
  onCategoryChange,
  cities,
  activeCity,
  onCityChange,
}: CategoryFilterProps) => {
  const [showAllCities, setShowAllCities] = useState(false);
  const visibleCities = showAllCities ? cities : cities.slice(0, 8);

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
          Category
        </h3>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategoryChange(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-gray-900 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>
      <div>
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
          City
        </h3>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onCityChange('All')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              activeCity === 'All'
                ? 'bg-gray-900 text-white shadow-md'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            All Cities
          </button>
          {visibleCities.map((city) => (
            <button
              key={city}
              onClick={() => onCityChange(city)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCity === city
                  ? 'bg-gray-900 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {city}
            </button>
          ))}
          {cities.length > 8 && (
            <button
              onClick={() => setShowAllCities(!showAllCities)}
              className="px-4 py-2 rounded-full text-sm font-medium text-teal-600 hover:bg-teal-50 transition-all cursor-pointer whitespace-nowrap"
            >
              {showAllCities ? 'Show Less' : `+${cities.length - 8} More`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
